import { ACTION_TYPES } from "../utils/enums";
import { ErrorModalContent, ErrorModal } from "../components/library/Modal";
import Faq from "../components/library/Faq";
import React from "react";
import { getErrorConfigByHttpResponseStatus, getPropsByHttpResponseStatus } from "../utils/errors";
import { get, mergeWith } from "lodash/object";
import uuid from '../utils/uuid';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import i18next from 'i18next';

function overwriteArrays(currentConfig, newConfig) {
 if (Array.isArray(newConfig)) {
   return newConfig;
 }
}

export const actions = {
  setHealthCheckPassedOrNotRequired: (bool) => ({
    type: ACTION_TYPES.SET_HEALTH_CHECK_PASSED_OR_NOT_REQUIRED,
    payload: bool,
  }),
  forceRefresh: () => ({
    type: ACTION_TYPES.FORCE_RE_RENDER,
    payload: uuid(),
  }),
  startOver: () => ({
    type: ACTION_TYPES.START_OVER,
  }),
  payment: {
    setPayment: data => ({
      type: ACTION_TYPES.PAYMENT.SET,
      payload: data,
    }),
    updatePayment: data => ({
      type: ACTION_TYPES.PAYMENT.UPDATE,
      payload: data,
    })
  },
  configuration: {
    updateConfiguration: data => ({
      type: ACTION_TYPES.CONFIGURATION.UPDATE,
      payload: data,
    })
  },
  tokens: {
    setToken: (tokenType, tokenValue) => ({
      type: ACTION_TYPES.TOKENS.SET,
      tokenType,
      tokenValue,
    }),
    resetTokens: () => ({
      type: ACTION_TYPES.TOKENS.RESET,
    })
  },
  accounts: {
    setAccounts: data => ({
      type: ACTION_TYPES.ACCOUNTS.SET,
      payload: data,
    })
  },

  selectedPaymentNetwork: {
    setSelectedPaymentNetwork: network => ({
      type: ACTION_TYPES.SELECTED_PAYMENT_NETWORK.SET,
      payload: network,
    }),
    resetSelectedPaymentNetwork: () => ({
      type: ACTION_TYPES.SELECTED_PAYMENT_NETWORK.RESET
    })
  },
  // cachedFunctions: {
  //   setCachedFunction: (name, fn) => ({
  //     type: ACTION_TYPES.CACHED_FUNCTIONS.SET,
  //     payload: {
  //       name,
  //       fn,
  //     },
  //   }),
  //   removeCachedFunction: name => ({
  //     type: ACTION_TYPES.CACHED_FUNCTIONS.REMOVE,
  //     payload: name,
  //   })
  // },
  modals: {
    pushModal: (content, options = {}) => ({
      type: ACTION_TYPES.MODALS.PUSH,
      props: {
        content,
        allowClose: true,
        ...options,
      }
    }),
    popModal: () => ({type: 'POP_MODAL'}),
    showErrorModal: ({allowClose = false, ...contentProps}) => {
      return {
        type: 'PUSH_MODAL',
        props: {
          content: <ErrorModal {...contentProps} />,
          allowClose,
        }
      }
    },
    showUiErrorModal: (configuration, {errorType, contentProps, buttonProps}) => {
      const config = get(configuration, `errors.uiErrors.${errorType}`, {});
      const { title, description, icon, allowClose, ...configProps } = config;

      return {
        type: 'PUSH_MODAL',
        props: {
          title,
          icon: icon || <FontAwesomeIcon className="modal-header-icon" icon={faExclamationCircle} size="lg" />,
          allowClose,
          content: <ErrorModalContent description={description} buttonProps={buttonProps} {...configProps} {...contentProps} />,
          className: 'error',
        }
      }
    },
    showHttpErrorModal: (configuration, {errorType, serverResponse, hideIcon = false, propsByHttpStatus = {}}) => {
      const { status } = serverResponse;

      const passedProps = getPropsByHttpResponseStatus(status, propsByHttpStatus);
      const {props: errorConfigProps} = getErrorConfigByHttpResponseStatus(errorType, status, configuration.errors);
      const { allowClose, showServerErrorMessage, title, ...contentProps } = mergeWith({}, passedProps, errorConfigProps, overwriteArrays);

      if(showServerErrorMessage && get(serverResponse, 'data.message')) contentProps.description = get(serverResponse, 'data.message');

      return {
        type: 'PUSH_MODAL',
        props: {
          title,
          content: <ErrorModalContent {...contentProps} />,
          icon: !hideIcon && <FontAwesomeIcon className="modal-header-icon" icon={faExclamationCircle} size="lg" />,
          allowClose,
          className: 'error',
        }
      }
    },
    showFaqs: () => ({
      type: 'PUSH_MODAL',
      props: {
        content: <Faq/>,
        allowClose: true,
        className: 'faqs',
        title: i18next.t('faqHeader'),
      }
    }),
  },
  sharedState: {
    setSharedState: data => ({
      type: ACTION_TYPES.SHARED_STATE.SET,
      payload: data,
    }),
    resetSharedState: () => ({
      type: ACTION_TYPES.SHARED_STATE.RESET,
    })
  }
};

export default actions;
